// import React, { useEffect, useState } from "react";
// import StoreHeader from "./StoreHeader";
// import { fetchCart } from "./ShopifyClient";

// // ----------------------------
// // Type for Shopify cart data
// // ----------------------------
// export type CartType = {
//   id: string;
//   checkoutUrl: string;
//   totalQuantity: number;
// };

// // ----------------------------
// // React component
// // ----------------------------
// const CartPage: React.FC = () => {
//   const [loading, setLoading] = useState(true);
//   const [showEmptyCartModal, setShowEmptyCartModal] = useState(false);
//   const [errorMessage, setErrorMessage] = useState<string | null>(null);

//   useEffect(() => {
//     const loadCartAndRedirect = async () => {
//       const cartId = localStorage.getItem("cart_id");
//       if (!cartId) {
//         setShowEmptyCartModal(true);
//         setLoading(false);
//         return;
//       }

//       try {
//         const cartData = await fetchCart(cartId);

//         if (cartData?.checkoutUrl && cartData.totalQuantity > 0) {
//           // ✅ Redirect directly to Shopify checkout
//           window.location.href = cartData.checkoutUrl;
//         } else {
//           setShowEmptyCartModal(true);
//           setLoading(false);
//         }
//       } catch (error) {
//         console.error("Error loading cart:", error);
//         setErrorMessage("Failed to load cart. Please try again.");
//         setLoading(false);
//       }
//     };

//     loadCartAndRedirect();
//   }, []);

//   const handleCloseModal = () => {
//     setShowEmptyCartModal(false);
//     setErrorMessage(null);
//     window.history.back();
//   };

//   // ----------------------------
//   // Render component
//   // ----------------------------
//   return (
//     <>
//       <StoreHeader />
      
//       {/* Main content with conditional blur */}
//       <div className={`min-h-screen ${(showEmptyCartModal || errorMessage) ? 'blur-sm' : ''}`}>
//         {loading ? (
//           <div className="min-h-screen flex items-center justify-center bg-gray-50">
//             <div className="text-center">
//               <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-ely-teal border-t-transparent"></div>
//               <p className="mt-4 text-lg text-gray-600">Processing cart...</p>
//             </div>
//           </div>
//         ) : (
//           <div className="min-h-screen bg-gray-50"></div>
//         )}
//       </div>

//       {/* Empty Cart Modal */}
//       {showEmptyCartModal && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
//           <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm text-center">
//             <div className="mb-4">
//               <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-1.5 6M7 13l-1.5 6m0 0h9" />
//               </svg>
//             </div>
//             <h2 className="text-xl font-bold text-gray-900 mb-2">Your cart is empty</h2>
//             <p className="text-gray-600 mb-4 text-sm">
//               Browse our wines and vouchers to add items to your cart.
//             </p>
//             <button
//               onClick={handleCloseModal}
//               className="bg-ely-teal hover:bg-ely-teal/90 text-white px-4 py-2 rounded font-medium transition-colors duration-200 text-sm"
//             >
//               Continue Shopping
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Error Modal */}
//       {errorMessage && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
//           <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm text-center">
//             <div className="mb-4">
//               <svg className="mx-auto h-12 w-12 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16c-.77.833.192 2.5 1.732 2.5z" />
//               </svg>
//             </div>
//             <h2 className="text-xl font-bold text-gray-900 mb-2">Error</h2>
//             <p className="text-gray-600 mb-4 text-sm">{errorMessage}</p>
//             <button
//               onClick={handleCloseModal}
//               className="bg-ely-teal hover:bg-ely-teal/90 text-white px-4 py-2 rounded font-medium transition-colors duration-200 text-sm"
//             >
//               Go Back
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default CartPage;



import React, { useEffect, useState } from "react";
import StoreHeader from "./StoreHeader";
import { fetchCart } from "./ShopifyClient";

// ----------------------------
// Type for Shopify cart data
// ----------------------------
export type CartType = {
  id: string;
  checkoutUrl: string;
  totalQuantity: number;
};

// ----------------------------
// React component
// ----------------------------
const CartPage: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [showEmptyCartModal, setShowEmptyCartModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    const loadCartAndRedirect = async () => {
      const cartId = localStorage.getItem("cart_id");

      if (!cartId) {
        setShowEmptyCartModal(true);
        setLoading(false);
        return;
      }

      try {
        const cartData = await fetchCart(cartId);

        if (cartData?.checkoutUrl && cartData.totalQuantity > 0) {
          // ✅ Redirect to Shopify checkout
          localStorage.removeItem("cart_id");          // Prevent reprocessing
          sessionStorage.setItem("cartRedirected", "true"); // Mark that redirect happened
          window.location.href = cartData.checkoutUrl;
        } else {
          setShowEmptyCartModal(true);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error loading cart:", error);
        setErrorMessage("Failed to load cart. Please try again.");
        setLoading(false);
      }
    };

    // If we already redirected before, go back immediately
    if (sessionStorage.getItem("cartRedirected")) {
      sessionStorage.removeItem("cartRedirected");
      window.history.back();
      return;
    }

    loadCartAndRedirect();
  }, []);

  const handleCloseModal = () => {
    setShowEmptyCartModal(false);
    setErrorMessage(null);
    window.history.back();
  };

  // ----------------------------
  // Render component
  // ----------------------------
  return (
    <>
      <StoreHeader />

      {/* Main content with conditional blur */}
      <div className={`min-h-screen ${(showEmptyCartModal || errorMessage) ? 'blur-sm' : ''}`}>
        {loading ? (
          <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="text-center">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-ely-teal border-t-transparent"></div>
              <p className="mt-4 text-lg text-gray-600">Processing cart...</p>
            </div>
          </div>
        ) : (
          <div className="min-h-screen bg-gray-50"></div>
        )}
      </div>

      {/* Empty Cart Modal */}
      {showEmptyCartModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm text-center">
            <div className="mb-4">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-1.5 6M7 13l-1.5 6m0 0h9" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">Your cart is empty</h2>
            <p className="text-gray-600 mb-4 text-sm">
              Browse our wines and vouchers to add items to your cart.
            </p>
            <button
              onClick={handleCloseModal}
              className="bg-ely-teal hover:bg-ely-teal/90 text-white px-4 py-2 rounded font-medium transition-colors duration-200 text-sm"
            >
              Continue Shopping
            </button>
          </div>
        </div>
      )}

      {/* Error Modal */}
      {errorMessage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm text-center">
            <div className="mb-4">
              <svg className="mx-auto h-12 w-12 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">Error</h2>
            <p className="text-gray-600 mb-4 text-sm">{errorMessage}</p>
            <button
              onClick={handleCloseModal}
              className="bg-ely-teal hover:bg-ely-teal/90 text-white px-4 py-2 rounded font-medium transition-colors duration-200 text-sm"
            >
              Go Back
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CartPage;
